
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';

// Map of language codes to their full names
const languageNames = {
  en: 'English',
  es: 'Español',
  no: 'Norsk'
};

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  
  const handleLanguageChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-9 w-9 rounded-full">
          <Globe className="h-[1.2rem] w-[1.2rem]" />
          <span className="sr-only">Switch language</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => handleLanguageChange('en')}>
          {languageNames.en}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => handleLanguageChange('es')}>
          {languageNames.es}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => handleLanguageChange('no')}>
          {languageNames.no}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
